import axios from "axios";

const authEndpoint = "https://accounts.spotify.com/authorize?";
const clientId = "10ff71b2181a4ee19909431870ef03f4";
const redirectUri = "https://music-player-melody.vercel.app/#";
const scopes = ["user-library-read", "playlist-read-private"];

export const loginEndpoint = `${authEndpoint}client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scopes.join(
  "%20"
)}&response_type=token&show_dialog=true`;

const apiClient = axios.create({
  baseURL: "https://api.spotify.com/v1/",
});

export const setClientToken = (token) => {
  apiClient.interceptors.request.use(async function (config) {
    config.headers.Authorization = "Bearer " + token;
    return config;
    console.log(token)
  });
};

export default apiClient;
